module.exports = __webpack_public_path__ + "rpi.png?1003d2ab861392f3230718b3bc1bb94d";